import {createUseMutation} from "@irati/utils/services/apollo"
import {Checkout, MutationStartCheckoutArgs} from "@irati/types"
import startCheckoutMutation, {startCheckoutKey} from "../services/mutations/startCheckout"
import {checkoutErrorHandler} from "../services/errors/checkoutErrorHandler"

const useStartCheckoutMutation = createUseMutation<Checkout, MutationStartCheckoutArgs>(startCheckoutMutation, {
  key: startCheckoutKey,
  errorHandlers: [checkoutErrorHandler]
})

export default useStartCheckoutMutation
